
import React from 'react';
import { cn } from '@/lib/utils';
import { Flame } from 'lucide-react';

interface StreakCounterProps {
  count: number;
  className?: string;
}

const StreakCounter = ({ count, className }: StreakCounterProps) => {
  return (
    <div className={cn("flex items-center gap-2 bg-gradient-to-br from-orange-500/20 to-orange-600/20 backdrop-blur-sm rounded-lg px-4 py-2", className)}>
      <div className="relative">
        <Flame className="h-6 w-6 text-orange-500 animate-pulse-light" />
        <div className="absolute -bottom-1 -right-1 bg-white rounded-full w-3 h-3 flex items-center justify-center">
          <div className="w-2 h-2 bg-orange-500 rounded-full animate-pulse-light"></div>
        </div>
      </div>
      <div className="flex flex-col">
        <span className="text-sm font-medium text-muted-foreground">Current Streak</span>
        <span className="text-xl font-bold">{count} {count === 1 ? 'day' : 'days'}</span>
      </div>
    </div>
  );
};

export default StreakCounter;
